export default __webpack_public_path__ + "static/09-6427f92a86ed6160f13591ae74776bd5.jpg";